import React from "react";
import { SITE } from "../lib/constants";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/5 bg-[#020202] py-12"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <span className="w-9 h-9 rounded-full bg-gradient-to-br from-[#E6C35C] to-[#A88824] flex items-center justify-center text-black font-bold">
            D
          </span>
          <div>
            <div className="font-display text-white text-lg leading-none">{SITE.name}</div>
            <div className="text-xs text-[#737373] mt-1">{SITE.role}</div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 text-sm text-[#B0B0B0]">
          <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} className="hover:text-[#D4AF37]" data-testid="footer-phone">
            {SITE.phone}
          </a>
          <a href={`mailto:${SITE.email}`} className="hover:text-[#D4AF37]" data-testid="footer-email">
            {SITE.email}
          </a>
        </div>
        <div className="text-xs text-[#555]">
          © {new Date().getFullYear()} {SITE.name}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};
